var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 55,
    viewBox: "0 0 74 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_13368_115420)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5.5,
    width: 52,
    height: 33.5,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.875,
    y: 5.375,
    width: 52.25,
    height: 33.75,
    rx: 6.125,
    stroke: "#D6DCE5",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7353 15.3708H33.0791V29.1293H40.7353V15.3708Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5653 22.25C33.5641 20.925 33.8643 19.617 34.4433 18.4252C35.0223 17.2333 35.8649 16.1888 36.9072 15.3708C35.6164 14.3562 34.0662 13.7252 32.4338 13.55C30.8013 13.3748 29.1525 13.6624 27.6758 14.3799C26.1991 15.0975 24.954 16.2161 24.083 17.6078C23.2119 18.9995 22.75 20.6082 22.75 22.25C22.75 23.8918 23.2119 25.5005 24.083 26.8922C24.954 28.2839 26.1991 29.4025 27.6758 30.1201C29.1525 30.8376 30.8013 31.1252 32.4338 30.95C34.0662 30.7748 35.6164 30.1438 36.9072 29.1292C35.8649 28.3112 35.0223 27.2667 34.4433 26.0748C33.8643 24.883 33.5641 23.575 33.5653 22.25Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0641 22.25C51.0641 23.8918 50.6023 25.5005 49.7312 26.8922C48.8602 28.2839 47.6152 29.4025 46.1385 30.12C44.6619 30.8376 43.0131 31.1252 41.3806 30.95C39.7482 30.7748 38.198 30.1438 36.9072 29.1292C37.9487 28.3103 38.7906 27.2657 39.3695 26.074C39.9484 24.8824 40.2492 23.5748 40.2492 22.25C40.2492 20.9252 39.9484 19.6176 39.3695 18.426C38.7906 17.2343 37.9487 16.1897 36.9072 15.3708C38.198 14.3561 39.7482 13.7252 41.3806 13.55C43.0131 13.3748 44.6619 13.6624 46.1385 14.3799C47.6152 15.0975 48.8602 16.2161 49.7312 17.6078C50.6023 18.9995 51.0641 20.6082 51.0641 22.25Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2293 27.672V27.3903H50.3428V27.3329H50.0536V27.3903H50.1672V27.672H50.2293ZM50.7908 27.672V27.3324H50.7022L50.6002 27.566L50.4982 27.3324H50.4095V27.672H50.4721V27.4158L50.5677 27.6367H50.6326L50.7283 27.4153V27.672H50.7908Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_13368_115420",
    x: 0.75,
    y: 0.25,
    width: 72.5,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13368_115420"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_13368_115420",
    result: "effect2_dropShadow_13368_115420"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_13368_115420",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogo);
export default __webpack_public_path__ + "static/media/mastercard-logo.481dbe2bef41fb2a16733ed5354ac0c5.svg";
export { ForwardRef as ReactComponent };